import { cur, money } from '../lib/units';
import { Plus, Trash2 } from 'lucide-react';

export const WEATHER = ['sun', 'cloud', 'rain', 'snow', 'frost', 'wind'];
const WI = { sun: '☀️', cloud: '☁️', rain: '🌧️', snow: '🌨️', frost: '🥶', wind: '💨' };
export const CREW = ['skilled', 'foreman', 'helper', 'operator', 'apprentice'];
export const MACH = ['excavator', 'minidigger', 'truck', 'plate', 'compressor', 'pump'];
const RK = 'giss_rates';
const rates = () => { try { return JSON.parse(localStorage.getItem(RK)) || {}; } catch { return {}; } };
const n = (v) => (Number.isFinite(+v) ? +v : 0);

// labour & machine costs of one daily report
export function dailyTotals(d = {}) {
  const crew = (d.crew || []).reduce((s, r) => s + n(r.n || 1) * n(r.h) * n(r.rate), 0), crewH = (d.crew || []).reduce((s, r) => s + n(r.n || 1) * n(r.h), 0);
  const mach = (d.mach || []).reduce((s, r) => s + n(r.h) * n(r.rate), 0), machH = (d.mach || []).reduce((s, r) => s + n(r.h), 0);
  return { crew, crewH, mach, machH, total: crew + mach };
}

function Rows({ t, list, kinds, pre, crew, onChange }) {
  const set = (i, p) => { const next = list.map((r, k) => (k === i ? { ...r, ...p } : r)); if (p.rate != null) localStorage.setItem(RK, JSON.stringify({ ...rates(), [next[i].kind]: p.rate })); onChange(next); };
  const add = () => { const kind = kinds[0]; onChange([...list, { kind, n: crew ? '1' : undefined, h: '8', rate: rates()[kind] ?? '' }]); };
  return (
    <div className="dr-rows">
      {list.map((r, i) => (
        <div key={i} className="dr-row" data-testid={`daily-${pre}-row-${i}`}>
          <select data-testid={`daily-${pre}-kind-${i}`} value={r.kind} onChange={(e) => set(i, { kind: e.target.value, rate: r.rate || rates()[e.target.value] || '' })}>{kinds.map((k) => <option key={k} value={k}>{t['dr_' + k]}</option>)}</select>
          {crew && <input inputMode="numeric" data-testid={`daily-${pre}-n-${i}`} title={t.drCount} value={r.n ?? ''} onChange={(e) => set(i, { n: e.target.value })} />}
          <input inputMode="decimal" data-testid={`daily-${pre}-h-${i}`} title={t.drHours} value={String(r.h ?? '').replace('.', ',')} onChange={(e) => set(i, { h: e.target.value.replace(',', '.') })} /><small>h</small>
          <input inputMode="decimal" data-testid={`daily-${pre}-rate-${i}`} title={t.drRate} placeholder={`${cur()}/h`} value={String(r.rate ?? '').replace('.', ',')} onChange={(e) => set(i, { rate: e.target.value.replace(',', '.') })} />
          <b>{money(n(r.n || 1) * n(r.h) * n(r.rate))}</b>
          <button className="icon-btn danger" data-testid={`daily-${pre}-del-${i}`} onClick={() => onChange(list.filter((_, k) => k !== i))}><Trash2 size={13} /></button>
        </div>
      ))}
      <button className="btn btn-outline btn-sm" data-testid={`daily-${pre}-add`} onClick={add}><Plus size={13} /> {crew ? t.drAddCrew : t.drAddMach}</button>
    </div>
  );
}

export default function DailyReport({ t, report, updateReport }) {
  const d = report.daily || {}, tot = dailyTotals(d);
  const set = (p) => updateReport((r) => ({ daily: { ...(r.daily || {}), ...p } }));
  return (
    <div className="daily-report" data-testid="daily-report">
      <h3 className="sec"><span>👷</span>{t.drTitle}</h3>
      <div className="chip-group">
        {WEATHER.map((w) => <button key={w} className={`chip seg ${d.weather === w ? 'on' : ''}`} data-testid={`daily-weather-${w}`} onClick={() => set({ weather: d.weather === w ? null : w })}>{WI[w]} {t['drW_' + w]}</button>)}
        <label className="dr-temp">°C <input inputMode="decimal" data-testid="daily-temp-input" value={String(d.temp ?? '').replace('.', ',')} onChange={(e) => set({ temp: e.target.value.replace(',', '.') })} /></label>
      </div>
      <b className="dr-sub">{t.drCrew}</b>
      <Rows t={t} list={d.crew || []} kinds={CREW} pre="crew" crew onChange={(crew) => set({ crew })} />
      <b className="dr-sub">{t.drMach}</b>
      <Rows t={t} list={d.mach || []} kinds={MACH} pre="mach" onChange={(mach) => set({ mach })} />
      {tot.total > 0 && <p className="dr-total" data-testid="daily-total">{t.drCrew}: {tot.crewH} h · {money(tot.crew)} | {t.drMach}: {tot.machH} h · {money(tot.mach)} | <b>{t.drSum}: {money(tot.total)}</b></p>}
    </div>
  );
}

export const weatherIcon = (w) => WI[w] || '';
